











import Vue from "vue";
import ALERT_QUERY from "../graphql/AlertsQuery.gql";
import { AlertsQuery_alerts } from "../graphql/generatedTypes/AlertsQuery";

export default Vue.extend({
  name: "AlertBar",
  apollo: {
    alerts: {
      query: ALERT_QUERY
    }
  },
  data() {
    return {
      alerts: [] as AlertsQuery_alerts[],
      snackbar: true
    };
  },
  methods: {
    removeAlert(alert: AlertsQuery_alerts) {
      this.$alertService.removeAlert({ id: alert.id });
    }
  }
});
